<script setup lang="ts">
import type { HeaderProps } from '#layers/uk/types'

export interface LandingPageHeaderContainerProps extends Omit<HeaderProps, 'offers'> {}

// One hero for every variant; it picks its video from type.
const props = defineProps<LandingPageHeaderContainerProps>()

// Here, not in the page: a server query holds up its starter's whole subtree.
const { signupPromotions } = useSignupPromotions({ server: true, lazy: false })
</script>

<template>
    <LandingPageHeaderA v-bind="props" :offers="signupPromotions" />
</template>
